<template>
  <header id="page-topbar">
    <div class="navbar-header headerPage d-flex justify-content-between" style="height: 80px; padding: 24px">
      <el-button @click="backUrl" class="n-btn" type="primary" plain>Quay lại</el-button>
      <div class="headerPage-title">
        <p>{{ title }}</p>
      </div>
      <span v-if="title == 'Chi tiết sản phẩm'">
        <el-button class="n-btn" type="primary" v-if="dataPermission.includes('NSH_INV_ITEM_BALANCE')" plain
          @click="$emit('onSubmit', 'CST')">Chỉnh sửa tồn</el-button>
        <el-button class="n-btn" v-if="dataPermission.includes('NSH_ITEM_PROD_UPDATE')"
          @click="$emit('onSubmit', 'SPB')">Sửa phiên bản</el-button>
        <el-button class="n-btn" v-if="dataPermission.includes('NSH_ITEM_PROD_UPDATE')" type="primary"
          @click="$emit('onSubmit', 'STT')">Sửa thông tin</el-button>
      </span>

      <!-- <BaseButton v-else type="submit" @click="$emit('onSubmit', true)">
        {{ title === "Thêm mới sản phẩm" ? "Hoàn tất" : "Lưu chỉnh sửa" }}
      </BaseButton> -->
      <el-button v-else class="n-btn" type="primary" @click="$emit('onSubmit', true)">
        {{ title === "Thêm mới sản phẩm" ? "Hoàn tất" : "Lưu chỉnh sửa" }}</el-button>
    </div>
  </header>
</template>

<script>
import { getDataPermission } from '@/utils/auth';

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataPermission: getDataPermission()
    };
  },
  methods: {
    submit() { },
    backUrl() {
      const _path = (this.$route.matched[1]) ? this.$route.matched[1].path : this.$route.matched[0].path
      if (_path == '/items/update-item-info/:id' || _path == 'update-item-variations/:id' || _path == '/update-item-inventory/:id') {
        const _id = this.$route.params.id
        this.$router.push({ path: "/items/items-detail/" + _id })
      } else if (_path == '/items/items-detail/:id') {
        this.$router.push({ path: "/items" });
      } else {
        this.$router.go(-1)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
#page-topbar {
  z-index: 10 !important;

  .navbar-header {
    .headerPage {
      &-button-return {
        padding: 8px 14px;
        align-items: center;
        width: 87px;
        background: #ecf0fe;
        border: 1px solid #ecf0fe;
        box-sizing: border-box;
        border-radius: 6px;
        color: #3e69f6;
        font-weight: normal;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          background: #e2e8fc;
        }
      }

      &-title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        p {
          font-weight: 600;
          font-size: 24px;
          line-height: 125%;
          margin: 0px;
          color: #23313e;
          cursor: context-menu;
        }
      }

      &-button-submit {
        padding: 8px 14px;
        width: 91px;
        background: #3e69f6;
        border: 1px solid #3e69f6;
        box-sizing: border-box;
        border-radius: 6px;
        color: #ffffff;
        font-weight: normal;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          background: #365ee4;
        }
      }
    }
  }
}
</style>